import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { request, withRetry } from 'src/commons/utils/async-request';

const url = '/ccx/ajax/advertisingApiCsrf';

const requestWithRetry = withRetry<
  AxiosRequestConfig,
  Promise<AxiosResponse<{ csrfToken: string }>>
>(async (config) => {
  return request<{ csrfToken: string }>(config);
});

export default async (): Promise<string> => {
  try {
    const response = await requestWithRetry({ url });
    return response.data.csrfToken;
  } catch (e) {
    return '';
  }
};
